<template>
  <div>
    <el-alert
      v-if="isCash"
      :title="$t(`messages.${cashMsg}`)"
      type="warning"
      effect="dark"
      show-icon />
    <div id="navbarTracker">
      <android-navbar
        v-if="isAndroidMobile() && flags.isLogo"
        :with-logo="isWorkspaceLogo"
        :is-workspace-name="isWorkspaceName"
        :is-map="isMap"
        :order="order"
        :is-cash="isCash"
        :is-custom-logo="isCustomLogo"
        :delivery-code="deliveryCode" />
      <ios-navbar
        v-else-if="isIOSMobile() && flags.isLogo"
        :with-logo="isWorkspaceLogo"
        :is-workspace-name="isWorkspaceName"
        :is-map="isMap"
        :order="order"
        :is-custom-logo="isCustomLogo"
        :delivery-code="deliveryCode"
        :is-cash="isCash" />
      <div
        v-else
        v-show="showLogo && flags.isLogo"
        id="navbar">
        <div v-if="isWorkspaceLogo" class="logo-left">
          <div :class="isCustomLogo ? '' : 'circle'">
            <img :src="wsLogo" :class="isCustomLogo ? 'logo-workspace-custom' : 'logo-workspace'">
          </div>
        </div>
        <div v-if="showWorkspaceName" class="logo-name">
          <span>{{ isWorkspaceName }}</span>
        </div>
      </div>
      <div v-if="deliveryCode && showCode" class="navbar-text-pin" :class="(deliveryCode && isCash) ? 'pt-6' : 'pt-22'">
        <div>{{ $t('general.deliveryCode').toUpperCase() }}</div>
        <div>{{ deliveryCode }}</div>
      </div>
      <div v-if="!isCustomLogo" class="storyly-web">
        <storyly-web ref="storylyWeb" class="storyly-web-item" />
      </div>
    </div>
  </div>
</template>
<script>
// Utils
import { mapGetters } from 'vuex'
import { isMobile, isAndroidMobile, isIOSMobile, stringToBoolean } from '@/utils/functions'

// Components
import AndroidNavBar from '@/components/android/NavBar'
import IOSNavBar from '@/components/ios/NavBar'

export default {
  name: 'NavBar',
  components: {
    'android-navbar': AndroidNavBar,
    'ios-navbar': IOSNavBar
  },
  props: {
    isMap: {
      type: Boolean,
      default: () => false
    },
    showLogo: {
      type: Boolean,
      default: () => true
    },
    deliveryCode: {
      type: String,
      default: ''
    },
    showCode: {
      type: Boolean,
      default: false
    },
    isCash: {
      type: Boolean,
      default: false
    },
    showWorkspaceName: {
      type: Boolean,
      default: true
    },
    cashMsg: {
      type: String,
      default: 'cash'
    }
  },
  data() {
    return {
      flags: {
        isLogo: false
      }
    }
  },
  computed: {
    ...mapGetters(['prevent', 'toHome', 'order', 'wsCustom']),
    isWorkspaceLogo() {
      let showLogo = false
      if (this.order.workspace && this.order.workspace.logo) {
        showLogo = true
      }
      return showLogo
    },
    isWorkspaceName() {
      let name = ''
      if (this.order.workspace && this.order.workspace.name) {
        name = this.order.workspace.name
      }
      return name
    },
    isCustomLogo() {
      let _isCustomLogo = false
      if (this.wsCustom && this.wsCustom.isCustomLogo) {
        _isCustomLogo = stringToBoolean(this.wsCustom.isCustomLogo)
      }
      return _isCustomLogo
    },
    wsLogo() {
      let _logo = null
      if (this.order.workspace && this.order.workspace.logo) {
        _logo = this.order.workspace.logo
        if (this.order.businessUnit && this.order.businessUnit.logo) {
          _logo = this.order.businessUnit.logo
        }
      }
      return _logo
    }
  },
  mounted() {
    this.flags.isLogo = true
    if (this.$route && this.$route.query && this.$route.query.story_token) {
      this.$refs.storylyWeb.init({
        token: this.$route.query.story_token,
        props: {
          storyGroupTextColor: '#5864ff',
          storyGroupTextVisibility: true,
          storyGroupTextFont: 'roboto',
          storyGroupIconBorderColorSeen: ['#babfff', '#babfff'],
          storyGroupIconBorderColorNotSeen: ['#5864ff', '#5864ff'],
          storyGroupBorderRadius: '40',
          storyGroupTextWeight: 'bold',
          storyGroupMarginHorizontal: '1',
          storyGroupAlign: 'left'
        },
        events: {
          isReady: () => {
            this.flags.isLogo = false
          },
          noStoryGroup: () => {
            this.flags.isLogo = true
          }
        }
      })
    }
  },
  methods: {
    isMobile: function() {
      return isMobile()
    },
    isAndroidMobile: function() {
      return isAndroidMobile()
    },
    isIOSMobile: function() {
      return isIOSMobile()
    }
  }
}
</script>

